// Hand-off from the landing page pricing CTAs to the dashboard.
// When a visitor clicks "Get started" on Pro, Pro+, or Enterprise, we stash
// their selection here so that after signup → email verify → onboarding
// completes, the dashboard can auto-open the PlanPickerModal already showing
// the plan they picked (and the right monthly/annual cycle + Enterprise unit
// count if the metered tier was chosen).
//
// Lifetime: cleared the moment the dashboard consumes it. Survives across
// pages and reloads but not domains (localStorage is per-origin).

import type { BillingCycle, PlanCode } from '../types/api'

const KEY = 'nudge.pendingPlan'

export type PendingPlan = {
  plan: Extract<PlanCode, 'PRO' | 'PRO_PLUS' | 'ENTERPRISE'>
  cycle: BillingCycle
  units?: number
}

const ALLOWED_PLANS = new Set<PendingPlan['plan']>(['PRO', 'PRO_PLUS', 'ENTERPRISE'])

export function savePendingPlan(p: PendingPlan): void {
  try { localStorage.setItem(KEY, JSON.stringify(p)) } catch { /* private mode etc. */ }
}

export function readPendingPlan(): PendingPlan | null {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as PendingPlan
    if (!ALLOWED_PLANS.has(parsed?.plan)) return null
    if (parsed?.cycle !== 'MONTHLY' && parsed?.cycle !== 'ANNUAL') return null
    return parsed
  } catch {
    return null
  }
}

export function clearPendingPlan(): void {
  try { localStorage.removeItem(KEY) } catch { /* ignore */ }
}
